import { useCallback, useMemo, useState } from 'react';
import './App.css';
import AuthCard from './components/AuthCard';
import Workspace from './components/Workspace';
import { useAuth } from './hooks/useAuth';

const initialFormValues = {
  login: '',
  password: '',
  displayName: '',
};

function App() {
  const { user, token, loading, error, authenticate, logout, clearError } = useAuth();
  const [mode, setMode] = useState('login');
  const [formValues, setFormValues] = useState(initialFormValues);

  const handleChange = useCallback(
    (event) => {
      const { name, value } = event.target;
      if (error) {
        clearError();
      }
      setFormValues((prev) => ({ ...prev, [name]: value }));
    },
    [clearError, error]
  );

  const payload = useMemo(
    () => ({
      login: formValues.login,
      password: formValues.password,
      displayName: formValues.displayName?.trim() || undefined,
    }),
    [formValues]
  );

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      try {
        await authenticate(mode, payload);
      } catch {
        /* handled inside hook */
      }
    },
    [authenticate, mode, payload]
  );

  const toggleMode = useCallback(() => {
    setMode((prev) => (prev === 'login' ? 'register' : 'login'));
    setFormValues((prev) => ({
      ...prev,
      password: '',
    }));
    clearError();
  }, [clearError]);

  if (!user) {
    return (
      <div className="app-shell">
        <div className="app-grid">
          <AuthCard
            mode={mode}
            formValues={formValues}
            onChange={handleChange}
            onSubmit={handleSubmit}
            toggleMode={toggleMode}
            disabled={loading}
            error={error}
          />
          <footer>
            <p>Backend: Express + MySQL; Client: React. Next step - wire up the generator and payments.</p>
            <small>Remember to update .env with production API/DB secrets before deployment.</small>
          </footer>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell app-shell--workspace">
      <div className="workspace-container">
        <header className="workspace-header">
          <div>
            <p className="workspace-header__eyebrow">Modskill Image Lab</p>
            <h1>Панель генерации изображений</h1>
          </div>
          <div className="workspace-header__user">
            <span>{user.displayName || user.login}</span>
            <button type="button" onClick={logout}>
              Выйти
            </button>
          </div>
        </header>
        <Workspace token={token} />
      </div>
    </div>
  );
}

export default App;
